
import tips from '../../loader/widget/tips'
import nmcConfig from '../../loader/config/config'
var cache = {};

/**
 * 数据管理
 * @class dataManager
 * @static
 */
var dataManager = {

    _errorHandler: function (ret, tipErr) {
        var reqErrorHandler = nmcConfig.reqErrorHandler;

        if (reqErrorHandler && reqErrorHandler(ret) === false) {
            return false
        }

        if (typeof tipErr == 'function') {
            tipErr = tipErr(ret);
        }

        //错误提示
        tipErr !== false && tips.error(ret.msg || nmcConfig.defaultReqErr);
    },

    /**
     * 公共回调
     * @method commonCb
     * @param {Object}   ret       CGI返回JSON对象
     * @param {Function} cb        成功回调(ret.code == 0)
     * @param {Function} fail      失败回调
     * @param {String}   cacheKey  缓存key
     * @param {Boolean}  tipErr    提示公共错误 @default true
     * @author evanyuan
     */
    commonCb: function (ret, cb, fail, cacheKey, tipErr) {
        var _self = this,
            _code = ret.code;
        if (_code == 0) {
            /*only,en;
            ret.data = nmcConfig.adapter(ret.data);
            only*/
            cb && cb(ret.data);
            if (cacheKey) {
                this.set(cacheKey, ret.data);
            }
        } else {
            /*only,en;
            ret = nmcConfig.adapter(ret);
            only*/
            _self._errorHandler(ret, tipErr);
            fail && fail(ret);
        }
    },

    /**
     * 获取缓存数据
     * @method get
     * @param {String} name 名称
     * @return 缓存数据
     * @author evanyuan
     */
    get: function (name) {
        return cache[name];
    },

    /**
     * 设置缓存数据
     * @method set
     * @param {String} name 名称
     * @param value 值
     * @author evanyuan
     */
    set: function (name, value) {
        cache[name] = value;
    },

    /**
     * 获取所有缓存数据
     * @method getCache
     * @return cache 缓存对象
     * @author evanyuan
     */
    getCache: function () {
        return cache;
    },

    /**
     * 清除所有缓存数据
     * @method clearCache
     * @author evanyuan
     */
    clearCache: function () {
        cache = {};
    }
};

export default dataManager



